import {Icon, SharedColors, Spinner, SpinnerSize, Stack, Text,} from "@fluentui/react";
import React, {FC} from "react";
import {theme} from "../index";

interface IListIconButton {
    name: string;
    onClick?: (e: React.MouseEvent<any, any>) => void;
    text?: string;
    color?: string;
    id?: string;
    disabled?: boolean;
    relative?: boolean;
    loading?: boolean;
    title?: string;
}

export const ListIconButton: FC<IListIconButton> = ({
                                                        title,
                                                        name,
                                                        onClick,
                                                        text,
                                                        color,
                                                        id,
                                                        disabled,
                                                        relative,
                                                        loading,
                                                    }) => {
    // return <IconButton
    //     onClick={event => {
    //         event.preventDefault();
    //         event.stopPropagation();
    //         if (onClick) onClick();
    //     }}
    //     iconProps={{ iconName: name }}
    //     cellPadding={0}
    //     style={{ padding: 0, margin: 0, position: "absolute", left: 10, top: 0, color: disabled ? SharedColors.gray10 : color ?? theme.palette?.themePrimary }}
    //     disabled={disabled}
    //     onRenderIcon={loading ? () => <Spinner /> : undefined}
    // />;

    return (
        <span className={onClick && !disabled ? "has-clickable-action" : ""}>
      <Stack
          data-selection-disabled={true}
          id={id}
          title={title}
          styles={{
              root: {
                  cursor: onClick && !disabled ? "pointer" : undefined,
                  color: disabled
                      ? SharedColors.gray10
                      : (color ?? theme.palette?.themePrimary),
                  ...(relative
                      ? {}
                      : {
                          position: "absolute",
                          paddingLeft: 10,
                          paddingTop: 7,
                          paddingBottom: 7,
                          paddingRight: 10,
                          left: 0,
                          top: 0,
                      }),
              },
          }}
          horizontal
          tokens={{childrenGap: 5}}
          onClick={
              disabled
                  ? undefined
                  : (e) => {
                      e?.preventDefault();
                      e?.stopPropagation();
                      if (onClick) onClick(e);
                  }
          }
          verticalAlign={"center"}
      >
        {loading ? (
            <Spinner size={SpinnerSize.small} style={{}}/>
        ) : (
            <Icon iconName={name} style={{fontSize: 18}}/>
        )}
          {/* <IconButton iconProps={{ iconName: name }} style={{ color }} onClick={onClick} onRenderIcon={loading ? () => <Spinner size={SpinnerSize.xSmall} /> : undefined} /> */}
          {text && <Text variant={"small"}>{text}</Text>}
      </Stack>
    </span>
    );
};
